import OnboardingDetails from "manifest-core/classes/employerDashboard/onboardingDetails";
import User from "manifest-core/classes/employerDashboard/user";

export const UserState = {
  user: null as User | null,
  userFetched: false,
  fetchingUser: false,
  onboardingDetails: null as OnboardingDetails | null,
  onboardingDetailsFetched: false,
  fetchingOnboardingDetails: false,
  payrollProviders: [] as string[],
  fetchingPayrollProviders: false,
  payrollProvidersFetched: false,
  recordKeeperList: [] as string[],
  recordKeeperListFetched: false,
  fetchingRecordKeeperList: false,
  isHRISConnected: null as null | boolean,
};
